const translations = {
    clientNameFieldPlaceholder: 'Client',
    farmNameFieldPlaceholder: 'Farm Name'
};

export default translations;
